"use strict";

exports.__esModule = true;
exports.default = objectToKey;

function objectToKey(obj) {
  if (!obj) {
    return null;
  }

  var keys = Object.keys(obj);
  keys.sort();
  var sortedObj = keys.reduce(function (result, key) {
    result[key] = obj[key];
    return result;
  }, {});
  return JSON.stringify(sortedObj);
}